(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6066],{

/***/ 59779:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/design-ideas/bathroom-designs/beige-bathroom",
      function () {
        return __webpack_require__(60585);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 60585:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_bootstrap_Breadcrumb__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(52681);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_slick__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46066);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(31955);
/* harmony import */ var _api_services_js_others__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(63372);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(83346);
/* harmony import */ var _src_components_design_pages_imageList__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(36774);












const tileData = [
    {
        src: "https://images.orientbell.com/media/design-images/Beige - 42/300x450 SDH DUNGRI BROWN HL, SDG DUNGRI BROWN, SDG DUNGRI BEIGE.webp",
        alt: "Chic beige bathroom design showcasing a white sink and round mirror"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Beige - 42/300x450 SDH FINE DECOR HL, SDM FINE BROWN DK, SDM FINE BROWN LT, SDM FINE BROWN FL.webp",
        alt: "Modern beige bathroom with countertop sink and shower area"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Beige - 42/300x450 SDH HIBISCUS FLORA HL, SDG HIBISCUS BROWN DK, SDG HIBISCUS BROWN LT, SDM HIBISCUS BROWN FL.webp",
        alt: "Minimalist beige bathroom design with a small window and sleek shower area"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Beige - 42/300x450 SDH MONTE ART HL, SDG MONTE BROWN DK, SDG MONTE BROWN LT, SDF MONTE BROWN FL.webp",
        alt: "Elegant beige bathroom design featuring a countertop sink and large window"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Beige - 42/300x450 SDH ZONTE FLORA HL, SDG ZONTE BROWN DK, SDG ZONTE BROWN LT, SDM ZONTE BROWN FL.webp",
        alt: "Contemporary beige bathroom design with a round mirror, sink, and large window"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Beige - 42/300x450 SDH ZONTE SQUARE HL, SDM ZONTE SANDY DK, SDM ZONTE SANDY LT,DM ZONTE SANDY FL.webp",
        alt: "Stylish beige bathroom with a white bathtub and natural light"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Beige - 42/300x450 SHG MAHOGANY CUBE HL,SBG MAHOGANY WOOD BEIGE, SBG MAHOGANY WOOD CREMA, SFM MAHOGANY WOOD BEIGE.webp",
        alt: "Modern beige bathroom design with Mahogany Cube tiles, large window, and white bathtub"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Beige - 42/300x600 SDH ARADOR FLORA HL, SDM ARADOR BEIGE DK, SDM ARADOR BEIGE LT, SDM ARADOR BEIGE FL.webp",
        alt: "Beige Bathroom Design with Mahogany Wood Tile and Double Sink Cabinet"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Beige - 42/300x600 SDH ARENA FLORA HL, SDM ARENA SANDUNE DK, SDM ARENA SANDUNE LT, SDF ARENA SANDUNE FL.webp",
        alt: "Stylish SDH Arena Flora tiles in a beige bathroom design with a sink and bathtub"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Beige - 42/300x600 SDH MARFIL SQUARE HL, SDG MARFIL CREMA, SDM MARFIL BROWN FL.webp",
        alt: "Modern beige bathroom design with sink, western toilet, and Marfil tile accents"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Beige - 42/300x600 SDH SYLVIA BROWN HL, SDG SYLVIA BROWN, SDG SYLVIA CREMA.webp",
        alt: "Elegant beige bathroom design with Sylvia Brown tiles and storage cabinet"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Beige - 42/600x1200 Streak Sahara Grainy Choco & Sahara Choco.webp",
        alt: "White bathtub in beige bathroom design featuring Sahara Choco tiles and a large window"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Beige - 42/Baby Satin Onyx Marble & PGVT Onyx Crystal Ice.webp",
        alt: "Streak Sahara Grainy tiles in beige bathroom design with sink cabinet and window"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Beige - 42/Canto Crema_1 600x1200.webp",
        alt: "Canto Crema tiles in a beige bathroom design with sink, bathtub, and window"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Beige - 42/CARVING DECOR GEOMETRIC LINE ART & DGVT Coquina Sand Creama_600x1200 mm.webp",
        alt: "Geometric Line Art Tile in Beige Bathroom Design with Shower Area and Bathtub"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Beige - 42/Emboss Gloss Moroccan Art Brown & DGVT Coquina Sand Creama_600x1200 mm.webp",
        alt: "Beige bathroom design showcasing Coquina Sand Creama tiles, shower area, and window view"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Beige - 42/GFT SPH Geometric Sandune HL, GFT SPH Lisbon Floral HL, GFT SPB SAND CREMA & GFT SPB SAND SANDUNE__Bathroom Ambiance_Ceramic Sparkle Wall Tiles_300x450 MM.webp",
        alt: "GFT SPH Geometric Sandune HL Beige Bathroom Design with Sink and Bathtub"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Beige - 42/HBG Emperador Marble Brown, HHG Vintage8 Diamond HL & HBG Emperador Marble Beige 300X450 MM.webp",
        alt: "Modern Beige Bathroom with HBG Emperador Marble, Sink, and White Bathtub"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Beige - 42/HHG 3D Cylinder Oak Wood HL, HBG Venezia Oak Wood DK & HBG Venezia Oak Wood LT_300X450 MM.webp",
        alt: "Beige Bathroom Design with HHG 3D Cylinder Oak Wood Tile and double sink"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Beige - 42/ODG Accent Brown, ODG Accent Beige & ODH Accent Diamond Art HL.webp",
        alt: "Stylish Beige Bathroom Design Featuring Matte Black Sink, Mirror, and Window"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Beige - 42/SHG PINWEEL BROWN HL, SBG HIBISCUS BROWN DK & SBG HIBISCUS BROWN LT_300x450mm.webp",
        alt: "Beige Bathroom Design with SHG Pinwheel Brown Tiles, Bathtub, and Sink"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Beige - 42/SHG Poppers Cherry Blossom HL, SBG Beige DK Poppers Sand, SBG Beige LT Poppers Sand & SFM Beige DK Poppers Sand_300x450 mm.webp",
        alt: "Beige bathroom with SHG Poppers Cherry Blossom tile, mirror, and natural light"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Beige - 42/SHG VINE FLUID MARBLE HL, SBG FLUID MARBLE BEIGE DK, SBG FLUID MARBLE BEIGE LT & SFM NOVA MARBLE BEIGE _300x450mm.webp",
        alt: "SFM Nova Marble Beige Tile in Beige Bathroom with Bathtub & Sink"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Beige - 42/SHM MOORISH ART BROWN HL, SBM MAKSI DOT BROWN DK, SBM MAKSI DOT BROWN LT & SFM MAKSI DOT BROWN DK_300x450mm.webp",
        alt: "Modern beige bathroom with Moorish Art Brown tile, bathtub, and sink"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Beige - 42/SPH Dyna Geometric Multi HL, SPB Royal Dyna Marble Beige & Marble Brown_300x450 mm.webp",
        alt: "Elegant beige bathroom with SPH Dyna Geometric Multi tiles, bathtub, and sink with cabinet"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Beige - 42/ODG Armani Marble Crema & OHG Armani Marble Cutting HL_300x450 mm2.webp",
        alt: "Beige Bathroom Design with Countertop Sink and Armani Marble Crema Tiles"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Beige - 42/ODG Canika Brown Dk, ODG Canika Brown LT & ODH Canika Brown HL.webp",
        alt: "Modern beige bathroom design featuring a sink and white bathtub"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Beige - 42/ODG Opera Crema & OHG Wood Marble Cutting HL.webp",
        alt: "ODG Opera Crema tiles in a beige bathroom design, with a sink with mirror and shower area"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Beige - 42/ODG Vimal Brown DK, ODG Vimal Brown LT & ODH Vimal Flora HL_300x450 mm.webp",
        alt: "Sleek beige bathroom design with ODG Vimal Brown tiles, sink with mirror, and bathtub"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Beige - 42/ODH Embroidery Flora HL, ODG Embroidery Beige DK, ODG Embroidery Beige LT & ODM Embroidery (EC) Beige LT FL_Bathroom Ambiance_Ceramic Wall Tiles_300x600 MM.webp",
        alt: "Elegant Beige Bathroom Design with ODH Embroidery Tiles, sink, and Mirror"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Beige - 42/ODH Omega HL, ODG Omega Beige DK, ODG Omega Beige LT_Bathroom_300x450 MM.webp",
        alt: "Omega Beige Tiles for a Stylish Beige Bathroom Design with Sink and Round Mirror"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Beige - 42/ODH PRINTEX FLORA HL, ODM PRINEX BROWN, ODM PRINTEX IVORY_300X600 MM.webp",
        alt: "Trendy Beige Bathroom Design with White Bathtub and Large Window"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Beige - 42/ODH TABLON BROWN HL,ODG TABLON BROWN & ODG TABLON BEIGE_300x450 MM.webp",
        alt: "Stylish beige bathroom design with ODH Tablon Beige tiles and a spacious shower area"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Beige - 42/odhTravertine flora hl, odg travertine brown dk, odg travertine brown lt , 300x450.webp",
        alt: "Sophisticated Beige Bathroom with ODG Travertine Brown DK, Mirror & Sink"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Beige - 42/OHG Emperador Marble Strips HL, ODG Emperador Marble Brown & ODG Emperador Marble Creama_300x600 mm.webp",
        alt: "Emperador Marble Brown Tile for Luxurious Shower Area & Sink in Beige Bathroom Design"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Beige - 42/OHG Line Travertine Brown HL, ODG TRAVERTINE BROWN LT & DK_300x450 mm.webp",
        alt: "Small window and sink with cabinet in a beige bathroom design featuring ODG Travertine Brown tiles"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Beige - 42/SHG Beige Dyna Mosaic HL, SBG Beige Dyna Marble, SBG Creama Dyna Marble & SFM Beige Dyna Marble_300x450 mm.webp",
        alt: "SHG Beige Dyna Mosaic tiles in a stylish beige bathroom design with a sleek sink"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Beige - 42/SHG Beige Popsicle Arabic HL, SBG Beige DK Popsicle, SBG Beige LT Popsicle & SFM Beige DK Popsicle_300x450 mm.webp",
        alt: "SBG Beige LT Popsicle tiles complementing a beige bathroom design with sink and mirror"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Beige - 42/SHG Brown Streak Dusk Strip HL, SBG Brown Streak Dusk, SBG Beige Streak Dusk & SFM Brown Streak Dusk_300x450 mm.webp",
        alt: "Elegant Shower Area and Sink with Mirror in a beige Bathroom Design"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Beige - 42/SHG Ethanic Floral Strip HL, SBG Brown Ethnic Grid Strip, SBG Creama Ethnic Grid Strip SFM Brown Ethnic Grid Strip_300x450 mm.webp",
        alt: "Beige bathroom design with SHG Ethanic Floral Strip tile, sink, and window"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Beige - 42/SHG Grainy Geometric Boho Art HL, SBG Beige DK Grainy, SBG Beige LT Grainy & SFM Beige DK Grainy_300x450 mm.webp",
        alt: "Modern beige bathroom design featuring with large window and countertop sink"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Beige - 42/SHG Petal Gold Art HL, SBG Brown River Wave, SBG Creama River Wave & SFM Brown River Wave_300x450 mm.webp",
        alt: "SBG Brown River Wave tiles in beige bathroom design with sink and shower area"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Beige - 42/Modern beige bathroom with mosaic tiles.webp",
        alt: "Modern Beige bathroom featuring patterned mosaic tiles"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Beige - 42/Beige bathroom with freestanding bathtub.webp",
        alt: "Beige bathroom designed with sleek freestanding bathtub"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Beige - 42/Luxurious beige bathroom with toilet and sink.webp",
        alt: "Luxurious beige bathroom ideas with basin and cabinets"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Beige - 42/Small beige bathroom, brown and metallic tiles.webp",
        alt: "Small beige bathroom design with brown and metallic tiles"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Beige - 42/Contemporary beige bathroom ideas natural light.webp",
        alt: "Contemporary beige bathroom ideas with shower area and natural light"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Beige - 42/Elegant beige Bathroom design with floral tiles.webp",
        alt: "Elegant beige Bathroom design with patterned floral tiles"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Beige - 42/Beige Bathroom design pair with serene bathtub.webp",
        alt: "Stylish Beige Bathroom design with stylish vanity and serene bathtub"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Beige - 42/Small beige bathroom ideas with wooden bench.webp",
        alt: "Small beige bathroom ideas with wooden bench and a small sculpture"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Beige - 42/Bright beige bathroom design white bathub.webp",
        alt: "Bright beige bathroom design pair with white bathub and round mirror"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Beige - 42/Large glass windows with small beige bathroom.webp",
        alt: "Large glass windows with floating rectangular sink for small beige bathroom"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Beige - 42/Luxurious beige bathroom ideas, sleek sink.webp",
        alt: "Luxurious beige bathroom ideas with elegant shower area and sleek sink"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Beige - 42/Soft neutral tiles for modern beige bathroom.webp",
        alt: "Sleek furniture with soft neutral tiles for modern beige bathroom"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Beige - 42/Stylish beige bathroom with white wash basin.webp",
        alt: "Stylish Beige Bathroom design with classy white wash basin"
    }
];
const text = " A beige bathroom design is perfect for bringing a warm and sophisticated element into modern interior design. Being a versatile colour, it creates a soothing atmosphere and is ideal if you want to create a minimalistic yet chic bathroom. It pairs effortlessly with natural materials (like wood, stone, etc.), metallic accents, decor tiles, or bold decor elements, offering endless design possibilities. \nA modern beige bathroom can easily go with a contemporary as well as a classic theme. This neutral colour gives scope for creative layering of textures and finishes to achieve a more cohesive and stylish look. A beige bathroom design brings timeless elegance to your home interiors, effortlessly upgrading the overall ambience. Whether you want to highlight simplicity or add depth with contrasting elements, beige offers the perfect canvas to elevate your bathroom's charm.";
const faqs = [
    {
        question: "What aspects should I consider while planning a bathroom?",
        answer: "Consider the available area, the desired overall style, ventilation, lighting, storage needs, and ventilation. Do not forget to infuse your flair into the design as well but give priority to functionality also."
    },
    {
        question: "Can a small bathroom be made to appear bigger?",
        answer: "Yes, you can make a small bathroom look bigger with a few smart design choices. Using light colours like white or soft pastels can create an open feel. Large mirrors can reflect light and give an illusion of space. Opt for large tiles with fewer grout lines and install proper lighting. Keeping the d\xe9cor minimal and using wall-mounted fixtures also helps to make the room feel more spacious."
    },
    {
        question: "What are some of the recent trends in bathroom decor?",
        answer: "Popular trends in bathroom d\xe9cor focus on creating a spa-inspired ambiance with neutral tones, natural elements, and soft lighting. Patterned or textured wall tiles paired with stylish flooring and well-placed mirrors are commonly seen. Additionally, glossy marble tiles for walls combined with matte finish tiles for floors and metallic d\xe9cor elements, have become popular choices, offering a mix of elegance and contemporary style."
    },
    {
        question: "How to select the best flooring for my bathroom?",
        answer: "Select flooring materials that offer resistance against moisture, such as vitrified tiles or ceramic tiles. Orientbell Tiles has a collection of anti-skid tiles that will be ideal for a bathroom. Along with the practical side, consider your design choices, maintenance requirements, and budget."
    },
    {
        question: "Which type of lighting works the best in a bathroom?",
        answer: "You can go ahead with the combination of ambient, and accent lighting to make a bathroom seem cosy and well-lit. "
    },
    {
        question: "Is it better to work with an expert designer or can I design my own bathroom?",
        answer: "Hiring a designing expert brings experience, saves time, and brings a consistent style. However, if you are on a tight budget, creating your bathroom design is achievable with careful planning and study."
    }
];
const settings = {
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    centerMode: false,
    autoplaySpeed: 3000,
    arrows: true,
    dots: false,
    centerPadding: "0px",
    responsive: [
        {
            breakpoint: 991,
            settings: {
                arrows: true,
                centerMode: false,
                slidesToShow: 3
            }
        },
        {
            breakpoint: 768,
            settings: {
                arrows: true,
                centerMode: false,
                slidesToShow: 2
            }
        },
        {
            breakpoint: 641,
            settings: {
                arrows: true,
                centerMode: false,
                slidesToShow: 1
            }
        }
    ]
};
function BeigeBathroom() {
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    const [isExpertTalkClicked, setIsExpertTalkClicked] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
    const [activeIndex, setActiveIndex] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null);
    const [relatedBlogData, setRelatedBlogData] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]);
    const [isReadMore, setIsReadMore] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
    const [isMobile, setIsMobile] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
    const [showAll, setShowAll] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        getRelatedBlogs();
    }, []);
    const toggleReadMore = ()=>{
        setIsReadMore(!isReadMore);
    };
    var requestOptions = {
        method: "GET"
    };
    const getRelatedBlogs = async ()=>{
        // try{
        fetch("".concat(_config__WEBPACK_IMPORTED_MODULE_7__/* ["default"].HEADLESS_BASE_URL */ .Z.HEADLESS_BASE_URL, "/blog/wp-json/post/v2/category/term=bathroom-designs"), requestOptions).then((response)=>response.text()).then((result)=>{
            setRelatedBlogData(JSON.parse(result));
        }).catch((error)=>console.log("error", error));
    };
    const handleToggle = (index)=>{
        setActiveIndex(activeIndex === index ? null : index);
    };
    const maxChars = 300;
    const previewText = text.substring(0, maxChars);
    const remainingText = text.substring(maxChars);
    const displayedFAQs = showAll ? faqs : faqs.slice(0, 5);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: "Beige Bathroom Interior Design Ideas | Orientbell"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "title",
                        content: "Beige Bathroom Interior Design Ideas | Orientbell"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: "Explore beige bathroom interior design ideas featuring versatile tiles, modern accents, and soothing aesthetics for a luxurious and inviting look."
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "designpage-section",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "container",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Breadcrumb__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Breadcrumb__WEBPACK_IMPORTED_MODULE_9__/* ["default"].Item */ .Z.Item, {
                                    href: "https://www.orientbell.com",
                                    children: "Home"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Breadcrumb__WEBPACK_IMPORTED_MODULE_9__/* ["default"].Item */ .Z.Item, {
                                    href: "https://www.orientbell.com/design-ideas",
                                    children: "Design Ideas"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Breadcrumb__WEBPACK_IMPORTED_MODULE_9__/* ["default"].Item */ .Z.Item, {
                                    href: "https://www.orientbell.com/design-ideas/bathroom-designs",
                                    children: "Bathroom Designs"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Breadcrumb__WEBPACK_IMPORTED_MODULE_9__/* ["default"].Item */ .Z.Item, {
                                    href: "https://www.orientbell.com/design-ideas/bathroom-designs/beige-bathroom",
                                    children: "Beige Bathroom"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "designpage-heading-bx padding-spacing",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h4", {
                                    children: [
                                        "Showing ",
                                        tileData.length,
                                        " results for "
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                    children: "Beige Bathroom Design Ideas"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                    className: "description-text",
                                    children: [
                                        previewText,
                                        !isReadMore && text.length > maxChars && "...",
                                        isReadMore && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            children: remainingText
                                        }),
                                        text.length > maxChars && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                            onClick: toggleReadMore,
                                            children: isReadMore ? "Read Less" : "Read More"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "obl-master-design-section",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                    children: "Beige Bathroom Gallery"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "designpage-category-row inner-design-gallery",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_src_components_design_pages_imageList__WEBPACK_IMPORTED_MODULE_8__/* .ImageList */ .Y, {
                                        tileData: tileData
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "bottom-content",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "common-text-content-section",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                                    children: "Modern Beige Bathroom Ideas"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                    children: "Whether you are looking for a full bathroom remodel or small beige bathroom ideas, beige provides flexibility and warmth to every project. Here are some inspiring ideas to transform your bathroom with a modern vibe:"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                                                        children: "Warm and Inviting:"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                    children: "Beige bathroom interiors are very cosy and warm. This makes them an ideal choice for both spacious bathrooms and those with space limitations."
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                                                        children: " Mix Materials:"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                    children: "A blend of ceramic or vitrified tiles with natural elements like wood can give your beige bathroom a unique feel of style."
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                                                        children: "Minimalist Style:"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                    children: "A beige colour scheme works great for a clutter-free style. Pair it with clean lines and simple fixtures for a modern, understated design."
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                                                        children: " Accent Features: "
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                    children: "Contrast metallic or darker accent faucets, mirrors, or light fixtures. They are a great way to lift the look without overpowering any of your beige bathroom ideas."
                                                                }),
                                                                " "
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                                                        children: "Functional Fixtures: "
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                    children: "For modern design, choose simple-looking sinks, shower heads, and storage solutions that will match the overall aesthetic."
                                                                }),
                                                                " "
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "common-text-content-section",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                                    children: " How Do I Determine My Modern Beige Bathroom Layout?"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                    children: "Planning the layout of your modern beige bathroom should be a balance of look and practical aspects. Here are some key tips that can help you design an efficient and comfortable space:"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                                                        children: "Take note of the Available Space:"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                    children: "Your bathroom's size affects the planning of the entire\n                      layout. Measure the space available, and also plan for\n                      door and window installations. This would guide you in\n                      positioning your fixtures, such as the sink, toilet, and\n                      bathtub for optimum use."
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                                                        children: " Identify Your Needs"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                    children: "You should focus on the essentials that would make your bathroom functional. Think about creating separate shower spaces with glass or using wall-mounted shelves or niches to optimise storage and convenience in your daily routines."
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                                                        children: "Select the Right Style:"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                    children: "Choose a layout that appeals to your preferences, be it linear for its simplicity or open for having more space. Functional details such as a compact sink or storage cabinet can be a part of both the design and functionality of a space."
                                                                }),
                                                                " "
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                                                        children: "Prioritise Safety and Airflow:"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                    children: "There should be appropriate distances between fixtures, for both comfort and safety. All of the elements like the toilet, must provide appropriate space around them while also allowing the door to swing open without being forced aside. Proper spacing assists with airflow and easy movement in the bathroom."
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "common-text-content-section",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                                    children: "What Materials Should I Use in My Modern Beige Bathroom Design?"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                    children: "When designing a modern white bathroom, selecting the right materials is what can make all the difference. Here are some essentials to consider for your bathroom remodelling:"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                                                        children: " Bathroom Tiles (Wall and Floor): "
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                                    children: [
                                                                        "For both walls and the floor, the tiles are a great choice. Ceramic or vitrified tiles are apt for durability and easy maintenance. Beige bathroom tile with subtle patterns or textures shall add depth to your",
                                                                        " ",
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                                                            href: "https://www.orientbell.com/design-ideas/bathroom-designs",
                                                                            children: [
                                                                                "bathroom design",
                                                                                " "
                                                                            ]
                                                                        }),
                                                                        "without making the space dull and dark. For the floor, use matte finish tiles or anti-skid, which will give better grip and safety."
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                                                        children: " Countertop: "
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                    children: "Countertops are a functional need of any bathroom. You can go ahead with granite-like tile countertops which are durable and highly functional. They can withstand moisture and provide a sleek, polished look."
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                                                        children: "Cabinets:"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                    children: "White or neutral shades are perfect for giving a clean, modern look to the cabinets. Materials like MDF or hardwood with a smooth finish work best. They provide adequate storage and go well with the minimalist design of a modern bathroom."
                                                                }),
                                                                " "
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                                                        children: "Faucets and Hardware "
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                    children: "Modern finishes, such as chrome, gold, or rustic silver, for faucets and hardware can add a little bit of elegance. The easy maintenance and cleaning capabilities make them perfect for bathroom renovation."
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                                                        children: "Grout: "
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                    children: "A light-coloured grout like grey or white could go with your tiles because it blends in well and makes the bathroom look simple while still being easy to clean."
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "common-text-content-section",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                                    children: "How do I Decorate My Modern Beige Bathroom?"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                    children: "Balancing style, functionality, and personality are a must for decorating a modern white bathroom. Here are some simple yet effective ways to enhance the look of your bathroom:"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                            children: [
                                                                " ",
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                                                        children: " Select Complementary Colours"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                    children: "Beige can be your main colour, but adding subtle accents in shades like grey, black, or soft pastels adds warmth and depth. Think about incorporating any of these colours through paint or wallpaper to break up the monotony of beige. You can do that by adding accessories, towels, and storage cabinets."
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                            children: [
                                                                " ",
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                                                        children: " Use Statement Fixtures:"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                                    children: [
                                                                        "Modernise the bathroom fixtures, use brushed gold or chrome, a sleek faucet, an elegant shower head, and some unique light fixtures. These few changes here and there will change the vibe of your bathroom.",
                                                                        " "
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                            children: [
                                                                " ",
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                                                        children: " Bathroom Mirrors:"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                    children: "Add some functionality to the room while also making a\n                      statement; choose large, frameless bathroom mirrors or\n                      bold geometric frames for that extra dash of modern flair.\n                      They'll also reflect light into the bathroom, making the\n                      space feel larger."
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                                                        children: "Add pattern with tiles: "
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                    children: "You can add personality and texture to your beige bathroom with patterned tiles on the floor or walls to serve as a focal point. Geometric, subway, or mosaic patterns add life to a design without overwhelming the space."
                                                                }),
                                                                " "
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                                                        children: "Personalise with Accessories:"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                    children: "Add some character to your bathroom with small accessories like stylish soap dispensers, towel racks, and storage containers. Choose items that fit into your overall colour scheme and design for a consistent look."
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                                                        children: "Use Wall Space: "
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                    children: "If your bathroom lacks adequate storage space, make the\n                      most of your walls for floating shelves or cabinets that\n                      are mounted to the wall. It's very functional in keeping\n                      everything in an organised manner while creating a sleek\n                      look."
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                                                        children: "Add Greenery:"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                    children: "Add some houseplants to the modern bathroom design to give that touch of nature. Most succulents and ferns love bathrooms-they like the humid ambience and tend to add freshness and the cool green colour."
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "designpage-faq-section padding-spacing",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                            children: "FAQs About Beige Bathroom Design"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "newacd designpage-faq-row",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                                                    className: "accordion",
                                                    children: displayedFAQs.map((faq, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                                                    className: "toggle",
                                                                    onClick: ()=>handleToggle(index),
                                                                    children: [
                                                                        index + 1,
                                                                        ". ",
                                                                        faq.question
                                                                    ]
                                                                }),
                                                                activeIndex === index && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                                                                    className: "inner",
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                                        children: faq.answer
                                                                    })
                                                                })
                                                            ]
                                                        }, index))
                                                }),
                                                faqs.length > 5 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "tru_btn_new design-page",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                        className: "btn btn-primary",
                                                        onClick: ()=>setShowAll(!showAll),
                                                        children: showAll ? "Show Less" : "Read More"
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                (relatedBlogData === null || relatedBlogData === void 0 ? void 0 : relatedBlogData.length) > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "tile-related-blog",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                            className: "title",
                                            children: "Related Blogs"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "designpage-relatedpost-row",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_slick__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                                ...settings,
                                                children: relatedBlogData === null || relatedBlogData === void 0 ? void 0 : relatedBlogData.map((obj, index)=>{
                                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: "related-blog-col",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                className: "blog-figure",
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                    href: obj.permalink,
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                                        src: obj.image,
                                                                        loading: "lazy",
                                                                        alt: "Marble Tiles Vs Marble Slab: What is Better for Your Home?"
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                className: "blog-text",
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                        className: "listingDate",
                                                                        children: obj.date
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                        className: "listingHead",
                                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                            href: obj.permalink,
                                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                                dangerouslySetInnerHTML: {
                                                                                    __html: obj.title
                                                                                }
                                                                            })
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                        className: "listingText",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                                                children: [
                                                                                    " ",
                                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                                        dangerouslySetInnerHTML: {
                                                                                            __html: obj.content.slice(0, -11)
                                                                                        }
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                                className: "listingButton",
                                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                                    href: obj.permalink,
                                                                                    children: "Read More"
                                                                                })
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }, index);
                                                })
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["default"] = (BeigeBathroom);


/***/ }),

/***/ 36774:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ ImageList; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31955);
/* harmony import */ var _api_services_js_others__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(63372);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6212);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4492);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(35005);





const ImageList = (param)=>{
    let { tileData  } = param;
    const [isExpertTalkClicked, setIsExpertTalkClicked] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [showAllTiles, setShowAllTiles] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [displayedTileData, setDisplayedTileData] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(tileData.slice(0, 6));
    const [touch, setTouch] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
        name: "",
        number: "",
        pincode: js_cookie__WEBPACK_IMPORTED_MODULE_2__/* ["default"].get */ .Z.get("pincode"),
        error: "",
        loading: false
    });
    const submitGetInTouch = async ()=>{
        const namee = touch.name;
        const no = touch.number;
        const pin = touch.pincode;
        if (!namee || !no || !pin) {
            setTouch({
                ...touch,
                error: "All fields are required"
            });
        } else if (String(pin).length != 6) {
            setTouch({
                ...touch,
                error: "Invalid Pincode"
            });
        } else {
            setTouch({
                ...touch,
                error: "",
                loading: true
            });
            let response = await (0,_api_services_js_others__WEBPACK_IMPORTED_MODULE_3__/* .getIntouch */ .JJ)({
                name: namee,
                phone: no,
                pincode: pin
            });
            if (response === null || response === void 0 ? void 0 : response.message) {
                localStorage.setItem("leadfilled", true);
                swal(response === null || response === void 0 ? void 0 : response.message);
                setTouch({
                    ...touch,
                    error: "",
                    loading: false
                });
            } else {
                swal(response.data.get_in_touch.msg);
                // setGetInTouch(false)
                setTouch({
                    name: "",
                    number: "",
                    error: "",
                    loading: false
                });
                setIsExpertTalkClicked(false);
            }
        }
    };
    const handleViewMore = ()=>{
        if (!showAllTiles) setDisplayedTileData((prev)=>[
                ...prev,
                ...tileData.slice(prev.length, prev.length + 6)
            ]);
        if (showAllTiles) setDisplayedTileData(tileData.slice(0, 6));
        if (displayedTileData.length + 6 >= tileData.length) setShowAllTiles(!showAllTiles);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "designpage-category-row inner-design-gallery",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "designpage-category-row inner-design-gallery",
                children: displayedTileData.map((tile, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "designpage-category-col",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "designpage-figure",
                                children: tile.src ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                    ...tile,
                                    loading: "lazy"
                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                    src: tile.image,
                                    alt: tile.alt,
                                    loading: "lazy"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "designpage-text",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                    className: "talk-expert-btn talk-to-expert-design-page",
                                    onClick: ()=>setIsExpertTalkClicked(true),
                                    children: "Talk to Expert"
                                })
                            })
                        ]
                    }, index))
            }),
            tileData.length > 6 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "tru_btn_new design-page",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                    className: "btn btn-primary",
                    onClick: handleViewMore,
                    children: showAllTiles ? "View Less" : "View More"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                show: isExpertTalkClicked,
                className: "pincode-popup-bx expert_assistance_modal ask-question-popup",
                onHide: ()=>{
                    // setTimePopup(false)
                    // setGetInTouch(false)
                    setIsExpertTalkClicked(false);
                // localStorage.setItem('leadSkiped',true)
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_4__/* ["default"].Dialog */ .Z.Dialog, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_4__/* ["default"].Header */ .Z.Header, {
                            closeButton: true,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_4__/* ["default"].Title */ .Z.Title, {
                                children: "Get in touch with our tile expert"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "ask-question-section",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "expert-fig-bx",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                        src: "/new-tareek.jpg"
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_4__/* ["default"].Body */ .Z.Body, {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                            children: "Ask Tile Expert"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            children: "Let Experts Help You In Buying Process"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                            onSubmit: (e)=>{
                                                e.preventDefault();
                                                submitGetInTouch();
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_5__/* ["default"].Group */ .Z.Group, {
                                                    className: "mb-3",
                                                    controlId: "formBasicEmail",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_5__/* ["default"].Label */ .Z.Label, {
                                                            children: "Name"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_5__/* ["default"].Control */ .Z.Control, {
                                                            type: "text",
                                                            onChange: (e)=>{
                                                                setTouch({
                                                                    ...touch,
                                                                    name: e.target.value
                                                                });
                                                            }
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_5__/* ["default"].Group */ .Z.Group, {
                                                    className: "mb-3",
                                                    controlId: "formBasicPassword",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_5__/* ["default"].Label */ .Z.Label, {
                                                            children: "Mobile"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_5__/* ["default"].Control */ .Z.Control, {
                                                            type: "number",
                                                            onChange: (e)=>{
                                                                setTouch({
                                                                    ...touch,
                                                                    number: "".concat(touch.countryCode || "").concat(e.target.value)
                                                                });
                                                            }
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_5__/* ["default"].Group */ .Z.Group, {
                                                    className: "mb-3",
                                                    controlId: "formBasicPassword",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_5__/* ["default"].Label */ .Z.Label, {
                                                            children: "Pincode"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_5__/* ["default"].Control */ .Z.Control, {
                                                            type: "number",
                                                            value: touch.pincode,
                                                            onChange: (e)=>{
                                                                setTouch({
                                                                    ...touch,
                                                                    pincode: e.target.value
                                                                });
                                                            }
                                                        })
                                                    ]
                                                }),
                                                touch.error && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                    className: "error text-danger",
                                                    children: touch.error
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                                    variant: "primary",
                                                    type: "submit",
                                                    disabled: touch.loading,
                                                    style: {
                                                        width: "100%"
                                                    },
                                                    children: touch.loading ? "Submitting" : "Submit"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};


/***/ }),

/***/ 52681:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _ThemeProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76792);
/* harmony import */ var _BreadcrumbItem__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(15094);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);





const Breadcrumb = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(({
  bsPrefix,
  className,
  listProps = {},
  children,
  label = 'breadcrumb',
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'nav',
  ...props
}, ref) => {
  const prefix = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_3__/* .useBootstrapPrefix */ .vE)(bsPrefix, 'breadcrumb');
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Component, {
    "aria-label": label,
    className: className,
    ref: ref,
    ...props,
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("ol", {
      ...listProps,
      className: classnames__WEBPACK_IMPORTED_MODULE_0___default()(prefix, listProps == null ? void 0 : listProps.className),
      children: children
    })
  });
});
Breadcrumb.displayName = 'Breadcrumb';
/* harmony default export */ __webpack_exports__["Z"] = (Object.assign(Breadcrumb, {
  Item: _BreadcrumbItem__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z
}));

/***/ }),

/***/ 15094:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _restart_ui_Anchor__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(13551);
/* harmony import */ var _ThemeProvider__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(76792);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);





const BreadcrumbItem = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(({
  bsPrefix,
  active = false,
  children,
  className,
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'li',
  linkAs: LinkComponent = _restart_ui_Anchor__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z,
  linkProps = {},
  href,
  title,
  target,
  ...props
}, ref) => {
  const prefix = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_4__/* .useBootstrapPrefix */ .vE)(bsPrefix, 'breadcrumb-item');
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Component, {
    ref: ref,
    ...props,
    className: classnames__WEBPACK_IMPORTED_MODULE_0___default()(prefix, className, {
      active
    }),
    "aria-current": active ? 'page' : undefined,
    children: active ? children : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(LinkComponent, {
      ...linkProps,
      href: href,
      title: title,
      target: target,
      children: children
    })
  });
});
BreadcrumbItem.displayName = 'BreadcrumbItem';
/* harmony default export */ __webpack_exports__["Z"] = (BreadcrumbItem);

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7312,7767,5518,4585,7615,6212,2770,3372,9774,2888,179], function() { return __webpack_exec__(59779); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);